export const SELECT_PATH = '/select'
export const WRITE_PATH = '/write'
export const MEDIA_PATH = '/media'
export const IMAGE_CROPPER_PATH = '/image-cropper'
export const EVENT_TIME_PATH = '/event-time'
export const EVENT_CATEGORY_PATH = '/event-category'
export const ADD_LOCATION_PATH = '/add-location'
export const PREVIEW_PATH = '/preview'
export const SUBMIT_PATH = '/submit'
export const SNAPSHOT_CROPPER_PATH = '/snapshot-cropper'
export const SNAPSHOT_WRITE_PATH = '/snapshot-write'
export const SNAPSHOT_LOCATION_PATH = '/snapshot-location'
